import { useIntl } from 'react-intl-next';
import { useDefaultSuppliers } from '../..';
import { usePeopleAndTeamsQuery } from '../../../common/clients/people-and-teams-supplier';
import { messages } from './messages';
import { getTeamData } from './teams-client';
import { CompassScope } from './types';
import { compassURLGenerators } from './url-generators';
import { peopleAndTeamsResultRenderer } from './result-renderer';
export const COMPASS_PRODUCT_ID = 'compass';
const NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
export const useCompassSuppliers = ({
  userTeamConfig,
  preQueryItemSupplier,
  postQueryItemSupplier
}, sections) => {
  var _resolveTeamUrl, _resolveUserUrl;
  const intl = useIntl();
  const itemSuppliers = useDefaultSuppliers(COMPASS_PRODUCT_ID, sections, {
    preQueryItemSupplier,
    postQueryItemSupplier
  });
  const peopleAndTeamSupplier = usePeopleAndTeamsQuery({
    people: {
      id: CompassScope.People,
      title: intl.formatMessage(messages.compass_people_section_heading)
    },
    teams: {
      id: CompassScope.Teams,
      title: intl.formatMessage(messages.compass_teams_section_heading)
    }
  }, 3);
  const requestTeamMeta = async teamId => {
    if (!teamId || teamId === NO_OWNER_TEAM) {
      return '';
    }
    try {
      const team = await getTeamData((userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.baseUrl) || '', teamId);
      return team.displayName;
    } catch (e) {
      // Ignore
      return '';
    }
  };
  const userTeamConfigOverride = {
    context: userTeamConfig.context,
    baseUrl: userTeamConfig.baseUrl,
    resolveTeamUrl: (_resolveTeamUrl = userTeamConfig.resolveTeamUrl) !== null && _resolveTeamUrl !== void 0 ? _resolveTeamUrl : compassURLGenerators().teamUrlGenerator,
    resolveUserUrl: (_resolveUserUrl = userTeamConfig.resolveUserUrl) !== null && _resolveUserUrl !== void 0 ? _resolveUserUrl : compassURLGenerators().userUrlGenerator
  };
  const hydrateOwnerMeta = async items => {
    const promises = [];
    const compSection = items.sections.find(s => s.id === CompassScope.Component);
    if (compSection) {
      compSection.searchResults.map(async res => {
        promises.push(requestTeamMeta(res.meta).then(teamName => res.meta = teamName));
      });
    }
    return Promise.all(promises).then(() => items);
  };
  const preQueryItemSupplierWithTeamName = async args => {
    const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
    const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find(section => section.id === CompassScope.Teams);
    return window.location.pathname.startsWith('/compass') ? existingSections : {
      size: existingSections.size,
      sections: [...existingSections.sections, ...(teamSection ? [{
        ...teamSection,
        resultRenderer: peopleAndTeamsResultRenderer
      }] : [])]
    };
  };
  const postQueryItemSupplierWithPeopleAndTeams = async args => {
    var _people$sections$map;
    const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
    const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
      ...userTeamConfigOverride,
      context: {
        ...userTeamConfigOverride.context,
        siteId: userTeamConfigOverride.context.siteId
      }
    }) : null;
    return {
      size: existingSections.size,
      sections: [...existingSections.sections, ...((_people$sections$map = people === null || people === void 0 ? void 0 : people.sections.map(section => ({
        ...section,
        resultRenderer: peopleAndTeamsResultRenderer
      }))) !== null && _people$sections$map !== void 0 ? _people$sections$map : [])]
    };
  };
  const preQuerySectionTitleGenerator = section => {
    switch (section.id) {
      case CompassScope.Component:
        return window.location.pathname.startsWith('/compass') ? intl.formatMessage(messages.compass_recently_viewed_components) : intl.formatMessage(messages.compass_components_section_heading);
      case CompassScope.Teams:
        return window.location.pathname.startsWith('/compass') ? intl.formatMessage(messages.compass_recently_viewed_teams) : intl.formatMessage(messages.compass_teams_section_heading);
      default:
        return '';
    }
  };
  return {
    preQueryItemSupplier: preQueryItemSupplierWithTeamName,
    postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
    preQuerySectionTitleGenerator
  };
};